import combined from './initiator/MewConnectInitiator.js';
export default combined;
